<template>
  <fragment>
    <FormSection class="pt-9 pb-9" title="SITUAÇÃO">
      <v-row>
        <v-col cols="12" sm="6" md="4" class="pr-sm-5">
          <BaseFormSelect
            id-element="advisory"
            placeholder="Situação"
            v-model="value.status"
            :items="creditLimitStatuses"
            item-text="nome"
            item-value="id"
            :return-object="true"
            required
            :rules="[requiredInput]"
            validate-on-blur
            label-text="Adicionar"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-sm-5">
          <BaseFormInput
            id-element="advisory-00"
            placeholder="DD/MM/YYYY"
            v-model="value.status_alterado_em"
            required
            :rules="[requiredInput, dateTermValid]"
            v-facade="maskDate"
            validate-on-blur
            label-text="Data de retorno"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-sm-5">
          <BaseFormInput
            id-element="advisory-date"
            placeholder="DD/MM/YYYY"
            v-model="value.solicitado_em"
            required
            :rules="[requiredInput, dateTermValid]"
            v-facade="maskDate"
            disabled
            validate-on-blur
            label-text="Data de solicitação"
          />
        </v-col>
      </v-row>
    </FormSection>
    <v-divider />
    <InsuranceContactSelection
      :value="value.contatos_relacionamento"
      :error-messages="contactsErrorMessage"
      @open-contact-modal="openModalInsurance"
    />
    <v-divider />
    <FormSection class="pt-9 pb-9" title="DADOS FINANCEIROS">
      <v-row>
        <v-col cols="12" md="4" class="pr-md-5" v-if="userAreaIsGarantia">
          <BaseMoney
            id-element="advisory-01"
            placeholder="Insira"
            v-model="value.valor_limite_credito"
            required
            :rules="[requiredInput]"
            validate-on-blur
            label-text="Limite de crédito"
          />
        </v-col>
        <v-col cols="12" md="4">
          <BaseFormInput
            id-element="advisory-02"
            placeholder="DD/MM/YYYY"
            v-model="value.inicio_validade"
            required
            :rules="[requiredInput, dateTermValid]"
            v-facade="maskDate"
            validate-on-blur
            label-text="Validade de"
          />
        </v-col>
        <v-col cols="12" md="4" class="pl-md-5">
          <BaseFormInput
            id-element="advisory-03"
            placeholder="DD/MM/YYYY"
            v-model="value.final_validade"
            required
            :rules="[requiredInput, dateTermValid]"
            v-facade="maskDate"
            validate-on-blur
            label-text="Até"
          />
        </v-col>
      </v-row>
    </FormSection>
    <v-divider />
    <FormSection>
      <v-row class="mt-5 mb-5">
        <v-col cols="12" md="4">
          <BaseFormSelect
            id-element="rule-type"
            placeholder="Selecionar"
            v-model="value.tipo_regra_aprovacao"
            required
            item-value="id"
            item-text="nome"
            :return-object="true"
            :items="approvalRules"
            :rules="[requiredInput]"
            label-text="Tipo de Regra"
          />
        </v-col>
        <v-col cols="12" md="8"></v-col>
        <v-col cols="12" md="2" class="pr-md-5">
          <BaseFormSelect
            id-element="ilimited-n1"
            placeholder="Selecionar"
            v-model="value.valor_ilimitado_n1"
            :return-object="true"
            required
            :items="listBoolean"
            item-value="id"
            item-text="nome"
            :rules="[requiredInput]"
            validate-on-blur
            label-text="Valor ilimitado?"
          />
        </v-col>
        <v-col cols="12" md="5" class="pr-md-5">
          <BaseMoney
            id-element="limite-maximo-n1"
            placeholder="Selecionar"
            v-model="value.valor_limite_maximo_n1"
            required
            :rules="[requiredInput]"
            :disabled="value.valor_ilimitado_n1.id"
            validate-on-blur
            label-text="1ª Faixa de Aprovação"
            :error-messages="approverValueN1ErrorMessage"
          />
        </v-col>
        <v-col cols="12" md="5">
          <BaseFormSelect
            id-element="aprovadores-n1"
            placeholder="Selecionar"
            v-model="value.aprovadores_n1"
            item-text="nome"
            item-value="id"
            :return-object="true"
            :items="users"
            multiple
            required
            :rules="[requiredInput, requiredApprover]"
            validate-on-blur
            label-text="Aprovadores"
          />
        </v-col>
        <v-col cols="12" md="2" class="pr-md-5">
          <BaseFormSelect
            id-element="ilimited-n2"
            placeholder="Selecionar"
            v-model="value.valor_ilimitado_n2"
            :return-object="true"
            required
            :items="listBoolean"
            item-value="id"
            item-text="nome"
            :rules="[requiredInput]"
            validate-on-blur
            label-text="Valor ilimitado?"
          />
        </v-col>
        <v-col cols="12" md="5" class="pr-md-5">
          <BaseMoney
            id-element="limite-maximo-n2"
            placeholder="Selecionar"
            v-model="value.valor_limite_maximo_n2"
            required
            :rules="[requiredInput]"
            validate-on-blur
            :disabled="value.valor_ilimitado_n2.id"
            label-text="2ª Faixa de Aprovação"
            :error-messages="approverValueN2ErrorMessage"
          />
        </v-col>
        <v-col cols="12" md="5">
          <BaseFormSelect
            id-element="aprovadores-n2"
            placeholder="Selecionar"
            v-model="value.aprovadores_n2"
            :items="users"
            multiple
            item-text="nome"
            item-id="id"
            :return-object="true"
            required
            :rules="[requiredInput, requiredApprover]"
            validate-on-blur
            label-text="Aprovadores"
          />
        </v-col>
      </v-row>
    </FormSection>
    <v-divider />
    <FormSection class="pt-9 pb-9" title="COMISSÃO BASE">
      <v-row>
        <v-col cols="12" sm="4" class="pr-sm-5">
          <BaseFormInput
            id-element="percentual-comissao"
            placeholder="Inserir valor"
            v-model="value.percentual_comissao"
            required
            :rules="[requiredInput]"
            type="number"
            validate-on-blur
            label-text="Perc. Comissão"
          />
        </v-col>
      </v-row>
    </FormSection>
    <v-divider />
    <FormSection class="pt-9" title="CO-CORRETAGEM">
      <CoBrokeringSelection :economic_group="value.grupo_economico"/>
    </FormSection>
    <v-divider v-if="userAreaIsGarantia" />
    <FormSection class="pt-9 pb-5" title="DADOS CCG" v-if="userAreaIsGarantia">
      <v-row>
        <v-col cols="12" sm="6" md="4" class="pr-sm-5">
          <BaseMoney
            id-element="emissao-sem-ccg"
            placeholder="Limite de crédito"
            v-model="value.valor_emissao_sem_ccg"
            required
            :rules="[requiredInput]"
            validate-on-blur
            label-text="Emissão s/ CCG"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <BaseFormSelect
            id-element="estrutura"
            placeholder="Selecionar"
            v-model="value.estrutura_ccg"
            :items="strutureCcg"
            required
            item-value="id"
            item-text="nome"
            :return-object="true"
            :rules="[requiredInput]"
            validate-on-blur
            label-text="Estrutura"
          />
        </v-col>
        <v-col cols="8">
          <label class="form__label primary--text">
            Anexar documento
          </label>
          <DropFile
            @selected-files="addFilesDocuments"
            :multiple="false"
            class="mb-5 mt-2"
            v-if="value.ccg_arquivo.length == 0"
          />
          <DocumentDataTable
            v-if="value.ccg_arquivo.length > 0"
            :documents="value.ccg_arquivo"
            @preview-file="onPreviewFile"
            @remove-file="onRemoveFileDocuments"
          />
          <BaseErrorMessages
            v-if="documentErrorMessage.length > 0"
            :error-messages="documentErrorMessage"
          />
        </v-col>
      </v-row>
    </FormSection>
    <BaseFooter>
      <div class="d-flex justify-end">
        <BaseButton
          class="error text-uppercase subtitle-2 font-weight-bold"
          min-width="200"
          :to="{ name: 'economic_group credit_limit list' }"
        >
          CANCELAR
        </BaseButton>
        <BaseButton
          @click="$emit('save-step', 'form')"
          class="secondary text-uppercase subtitle-2 font-weight-bold ml-5"
          min-width="200"
        >
          PRÓXIMO
        </BaseButton>
      </div>
    </BaseFooter>
    <SelectContactInsuranceModal
      v-model="modalInsurance"
      :items="relationshipContacts"
      :current-items="value.contatos_relacionamento"
      @select-contacts-insurance="updateContactInsurance"
      @close="closeModal"
    />
  </fragment>
</template>

<script>
import { requiredInput, dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import FormSection from "@/components/FormSection.vue";
import DropFile from "@/components/DropFile.vue";
import InsuranceContactSelection from "../../../components/form/InsuranceContactSelection.vue";
import CoBrokeringSelection from"../../../components/form/CoBrokeringSelection.vue";
import SelectContactInsuranceModal from "../../../components/SelectContactInsuranceModal.vue";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { FILE } from "@/mixins/DocumentsMixin";
import DocumentDataTable from "@/components/DocumentDataTable";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  name: "ConfigureLimit",
  components: {
    FormSection,
    InsuranceContactSelection,
    DropFile,
    SelectContactInsuranceModal,
    DocumentDataTable,
    CoBrokeringSelection,
  },
  nextStep() {
    return import("./ConfigureModalitySection.vue").then(c => c.default);
  },
  mixins: [DocumentsMixin],
  data() {
    return {
      maskDate,
      dateTermValid,
      requiredInput,
      modalInsurance: false,
      listBoolean: [
        {
          id: false,
          nome: "NÃO"
        },
        {
          id: true,
          nome: "SIM"
        }
      ]
    };
  },
  computed: {
    ...mapState("me", ["userAreaIsGarantia"]),
  },
  methods: {
    requiredApprover(item) {
      return (
        !this.ruleApprover() ||
        item.length > 0 ||
        "É preciso definir o(s) aprovador(es)"
      );
    },
    updateContactInsurance(items) {
      this.modalInsurance = false;
      this.value.contatos_relacionamento = _.cloneDeep(items);
    },
    closeModal() {
      this.modalInsurance = false;
    },
    openModalInsurance() {
      this.modalInsurance = true;
    },
    addFilesDocuments(files) {
      const documents = files.map(file => ({
        arquivo: {
          [FILE]: file,
          nome: file.name
        }
      }));
      this.value.ccg_arquivo = documents.slice(0, 1);
    },
    onRemoveFileDocuments(item) {
      this.value.ccg_arquivo = this.value.ccg_arquivo.filter(document =>
        document.arquivo.url
          ? document.arquivo.url !== item.arquivo.url
          : document.arquivo.nome !== item.arquivo.nome
      );
    }
  },
  props: {
    value: Object,
    creditLimitStatuses: Array,
    relationshipContacts: Array,
    strutureCcg: Array,
    users: Array,
    approvalRules: Array,
    contactsErrorMessage: Array,
    documentErrorMessage: Array,
    modalityErrorMessage: Array,
    approverValueN1ErrorMessage: Array,
    approverValueN2ErrorMessage: Array,
    ruleApprover: Function
  }
};
</script>
